import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';
// 상점 관리 상점별 배달대행료 수수료 그룹 페이지
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
